var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarNoNewFile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 182,
  height: 183,
  viewBox: "0 0 182 183",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_37490_36898)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.1274 107.944C9.01264 107.944 0 100.453 0 91.2126C0 86.5935 2.25498 82.4111 5.8968 79.3845C9.53862 76.356 14.5709 74.485 20.1292 74.485H27.4693C29.979 74.485 32.3796 74.1046 34.5927 73.4058L28.989 109.149C26.6685 108.372 24.1332 107.944 21.4796 107.944H20.1292H20.1274Z",
  fill: "url(#paint0_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182 158.132C182 162.753 179.745 166.934 176.103 169.96C172.461 172.989 167.427 174.86 161.871 174.86H20.1274C9.01264 174.86 0 167.369 0 158.13C0 153.511 2.25498 149.329 5.8968 146.302C9.53862 143.276 14.5709 141.401 20.1292 141.401H21.4796C23.842 141.401 26.1079 141.063 28.2118 140.442C28.4157 140.458 28.6268 140.462 28.8397 140.446L103.132 135.035C106.819 138.913 112.527 141.401 118.937 141.401H161.874C172.989 141.401 182.002 148.892 182.002 158.132H182Z",
  fill: "url(#paint1_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.873 74.4849H156.653C145.534 74.4849 136.525 66.9938 136.525 57.7555C136.525 53.1363 138.78 48.954 142.422 45.9273C146.064 42.9006 151.096 41.026 156.655 41.026H161.874C167.431 41.026 172.465 39.1533 176.107 36.1266C179.749 33.0999 182.004 28.9176 182.004 24.2984C182.004 15.0601 172.991 7.5708 161.876 7.5708H20.1274C14.5691 7.5708 9.5368 9.44176 5.89498 12.4702C2.25498 15.4951 0 19.6756 0 24.2966C0 33.5367 9.01264 41.026 20.1274 41.026H27.4674C38.3438 41.026 47.2072 48.1987 47.5821 57.1658L79.4612 53.2473L125.649 47.5708C129.611 47.0848 133.348 49.5345 134.48 53.3656L143.021 82.2672L146.708 94.7433C148.075 99.3625 145.165 104.156 140.435 105.077L125.686 107.947H161.869C167.425 107.947 172.46 106.076 176.101 103.048C179.743 100.021 181.998 95.839 181.998 91.218C181.998 81.9797 172.986 74.4904 161.871 74.4904L161.873 74.4849ZM133.515 37.7919H109.817L104.159 42.8133C102.925 43.9089 100.972 43.0317 100.972 41.3809V37.7919H94.8056C92.7017 37.7919 90.9982 36.0866 90.9982 33.9845V11.8296C90.9982 9.72568 92.7035 8.02216 94.8056 8.02216H133.513C135.617 8.02216 137.321 9.7275 137.321 11.8296V33.9845C137.321 36.0884 135.615 37.7919 133.513 37.7919H133.515Z",
  fill: "url(#paint2_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.622 67.8745C160.661 67.8745 165.557 62.9789 165.557 56.9399C165.557 50.9009 160.661 46.0054 154.622 46.0054C148.583 46.0054 143.688 50.9009 143.688 56.9399C143.688 62.9789 148.583 67.8745 154.622 67.8745Z",
  fill: "url(#paint3_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.2646 113.757L24.9176 135.107C18.8825 135.104 13.9922 130.21 13.9922 124.173C13.9922 118.136 18.888 113.238 24.9267 113.238C26.0915 113.238 27.2127 113.418 28.2646 113.757Z",
  fill: "url(#paint4_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.71 94.7393L134.48 53.3634C133.348 49.5341 129.611 47.0826 125.649 47.5685L42.9193 57.7369C38.666 58.2574 35.6393 61.9338 35.7449 66.0434C35.7594 66.5657 35.8231 67.0989 35.9432 67.6286L49.2747 127.226C50.2211 131.456 54.307 134.211 58.5822 133.503L74.2524 130.908C77.3555 130.395 79.889 128.149 80.7644 125.128L81.9729 120.965C82.8283 118.024 85.2543 115.808 88.2573 115.225L123.696 108.329L140.437 105.071C145.165 104.151 148.077 99.3566 146.71 94.7357V94.7393ZM104.02 85.1151L104.002 85.0551C103.625 83.7465 104.412 82.3851 105.731 82.0575L125.646 77.1089C126.883 76.8014 128.143 77.513 128.521 78.7287C128.596 78.9653 128.63 79.2074 128.63 79.4422C128.63 80.5142 127.908 81.4951 126.812 81.7718L106.914 86.7768C105.658 87.0935 104.377 86.3564 104.02 85.1115V85.1151ZM127.633 94.5737L112.587 98.2865C110.232 98.8707 107.871 97.3492 107.427 94.9613C107.378 94.7029 107.355 94.4426 107.355 94.1897C107.355 92.3205 108.601 90.6297 110.463 90.1238L125.422 86.0361C127.742 85.4045 130.119 86.8314 130.649 89.1774L130.732 89.5468C131.238 91.7891 129.861 94.0222 127.631 94.5737H127.633Z",
  fill: "url(#paint5_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.699 108.331L121.345 126.728C120.819 130.826 117.481 133.99 113.361 134.288L28.8383 140.445C26.3777 140.623 24.3902 138.465 24.7743 136.028L35.747 66.0435C35.7616 66.5658 35.8253 67.0991 35.9454 67.6287L49.2769 127.226C50.2233 131.456 54.3092 134.212 58.5844 133.504L74.2546 130.908C77.3577 130.395 79.8911 128.149 80.7666 125.128L81.975 120.966C82.8304 118.024 85.2565 115.808 88.2595 115.225L123.699 108.329V108.331Z",
  fill: "url(#paint6_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.63 94.5755L112.584 98.2883C110.229 98.8725 107.868 97.351 107.424 94.9632C107.375 94.7048 107.352 94.4445 107.352 94.1915C107.352 92.3224 108.598 90.6316 110.46 90.1256L125.419 86.0379C127.739 85.4064 130.116 86.8332 130.646 89.1792L130.729 89.5487C131.235 91.7909 129.858 94.0241 127.628 94.5755H127.63Z",
  fill: "url(#paint7_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.629 79.446C128.629 80.518 127.906 81.4989 126.811 81.7756L106.913 86.7806C105.657 87.0973 104.376 86.3602 104.019 85.1153L104.001 85.0552C103.624 83.7466 104.41 82.3853 105.73 82.0577L125.644 77.1091C126.882 76.8015 128.141 77.5131 128.52 78.7289C128.594 78.9655 128.629 79.2076 128.629 79.4423V79.446Z",
  fill: "url(#paint8_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.8745 64.844C41.6069 64.844 41.374 64.6475 41.3339 64.3763C41.2903 64.0778 41.4977 63.8012 41.7962 63.7575L123.622 52.0039C123.92 51.9621 124.197 52.1677 124.24 52.4662C124.284 52.7647 124.077 53.0413 123.778 53.085L41.9527 64.8386C41.9273 64.8422 41.9 64.844 41.8745 64.844ZM44.7246 73.0359C44.4571 73.0359 44.2241 72.8393 44.1841 72.5681C44.1404 72.2696 44.3479 71.993 44.6463 71.9493L70.6469 68.2092C70.9453 68.1655 71.222 68.373 71.2657 68.6715C71.3093 68.97 71.1019 69.2466 70.8034 69.2903L44.8029 73.0304C44.7756 73.034 44.7501 73.0359 44.7246 73.0359ZM81.9782 121.515C81.9272 121.515 81.8744 121.508 81.8217 121.492C81.5323 121.406 81.3685 121.1 81.454 120.813L88.188 98.2574C88.2736 97.968 88.5775 97.8042 88.8669 97.8898C89.1563 97.9753 89.3201 98.2811 89.2345 98.5686L82.5005 121.124C82.4295 121.361 82.213 121.513 81.9782 121.513V121.515Z",
  fill: "#CCD2D6"
})), /*#__PURE__*/React.createElement("path", {
  d: "M132.225 143.887C127.001 143.887 120.538 142.842 114.884 138.864C108.483 134.361 104.249 127.549 103.556 120.64C103.525 120.34 103.745 120.072 104.046 120.043C104.348 120.016 104.613 120.232 104.643 120.532C105.303 127.13 109.367 133.649 115.512 137.972C122.155 142.644 129.997 143.104 135.406 142.666C142.872 142.061 149.103 138.978 152.953 133.982C156.654 129.177 157.503 121.952 155.015 116.41C153.04 112.011 149.294 109.4 144.464 109.059C141.43 108.844 138.387 109.876 136.325 111.818C134.15 113.866 133.084 116.982 133.606 119.752C134.154 122.658 136.463 125.093 139.221 125.674C141.916 126.242 144.781 124.88 145.742 122.576C146.233 121.399 146.109 119.903 145.418 118.672C144.803 117.579 143.836 116.856 142.762 116.69C142.464 116.645 142.26 116.366 142.306 116.068C142.351 115.77 142.631 115.564 142.928 115.611C144.335 115.828 145.591 116.749 146.37 118.137C147.234 119.677 147.376 121.492 146.748 122.995C145.593 125.767 142.187 127.414 138.995 126.741C135.817 126.073 133.16 123.281 132.532 119.952C131.943 116.825 133.136 113.318 135.575 111.021C137.856 108.874 141.206 107.731 144.539 107.967C149.788 108.338 153.861 111.178 156.008 115.961C158.653 121.854 157.75 129.538 153.815 134.647C149.777 139.888 143.268 143.122 135.492 143.752C134.478 143.834 133.38 143.885 132.223 143.885L132.225 143.887ZM87.793 173.185C86.5317 173.185 85.2996 172.881 84.1293 172.27C81.3629 170.828 79.2754 167.732 78.6802 164.194C78.2762 161.794 78.622 159.433 79.6521 157.548C80.8005 155.447 82.6824 154.104 85.0921 153.666C86.9758 153.322 88.5701 153.858 89.582 155.174C90.7432 156.687 90.9234 158.975 90.0297 160.867C89.1671 162.695 87.4708 163.783 85.3724 163.854C85.0702 163.858 84.8191 163.628 84.8082 163.326C84.7972 163.024 85.0338 162.773 85.336 162.762C87.6292 162.684 88.6429 161.25 89.0433 160.401C89.7549 158.893 89.6202 157.016 88.7175 155.839C87.9568 154.849 86.7719 154.466 85.2886 154.738C80.5621 155.6 79.1079 160.148 79.7577 164.012C80.2964 167.221 82.1655 170.013 84.6353 171.301C86.6555 172.355 88.9068 172.352 91.1418 171.29C100.777 166.719 101.337 152.379 100.813 144.24C100.269 135.78 98.9168 129.241 96.5563 123.659C96.438 123.381 96.569 123.06 96.8456 122.944C97.1223 122.826 97.4444 122.957 97.5609 123.233C99.9706 128.93 101.35 135.582 101.902 144.169C102.167 148.291 102.182 154.355 100.744 159.834C99.1315 165.98 96.0576 170.166 91.6095 172.277C90.3337 172.883 89.0506 173.185 87.793 173.185ZM109.223 175.977C108.921 175.977 108.677 175.731 108.679 175.429C108.725 161.959 108.017 146.293 102.438 132.215C102.327 131.935 102.464 131.618 102.744 131.507C103.025 131.396 103.341 131.533 103.452 131.813C109.1 146.062 109.815 161.859 109.769 175.433C109.769 175.733 109.524 175.977 109.223 175.977ZM121.221 151.627C121.141 151.627 121.061 151.609 120.984 151.573C116.079 149.21 111.795 145.365 108.92 140.744C108.759 140.487 108.839 140.15 109.094 139.992C109.351 139.832 109.688 139.912 109.846 140.167C112.614 144.615 116.738 148.317 121.457 150.59C121.729 150.721 121.843 151.047 121.712 151.318C121.618 151.513 121.423 151.627 121.219 151.627H121.221Z",
  fill: "#CCD2D6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.515 8.02197H94.8074C92.7035 8.02197 91 9.72731 91 11.8294V33.9861C91 36.09 92.7053 37.7935 94.8074 37.7935H100.974V41.3826C100.974 43.0333 102.925 43.9106 104.159 42.8149L109.817 37.7954H133.515C135.619 37.7954 137.323 36.09 137.323 33.9879V11.8294C137.323 9.72549 135.617 8.02197 133.515 8.02197Z",
  fill: "url(#paint9_linear_37490_36898)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.672 24.1361C120.672 26.6604 120.106 28.606 118.972 29.9746C117.839 31.3433 116.241 32.0276 114.18 32.0276C112.102 32.0276 110.493 31.3396 109.356 29.9619C108.218 28.5841 107.648 26.6422 107.648 24.1361V20.7236C107.648 18.1992 108.214 16.2536 109.348 14.885C110.482 13.5164 112.084 12.832 114.153 12.832C116.222 12.832 117.828 13.52 118.965 14.8977C120.103 16.2755 120.672 18.2211 120.672 20.7363V24.1361ZM116.348 20.1703C116.348 18.8271 116.173 17.8243 115.822 17.1618C115.471 16.4993 114.916 16.1681 114.153 16.1681C113.391 16.1681 112.868 16.4757 112.53 17.0927C112.191 17.7078 112.009 18.6415 111.984 19.89V24.6639C111.984 26.058 112.158 27.079 112.51 27.7251C112.861 28.3712 113.416 28.6933 114.179 28.6933C114.914 28.6933 115.458 28.3785 115.808 27.7506C116.159 27.1227 116.337 26.1362 116.346 24.7931V20.1739L116.348 20.1703Z",
  fill: "url(#paint10_linear_37490_36898)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_37490_36898",
  x1: 17.2955,
  y1: 28.237,
  x2: 17.2955,
  y2: 154.318,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_37490_36898",
  x1: 91,
  y1: 28.2371,
  x2: 91,
  y2: 154.318,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_37490_36898",
  x1: 91,
  y1: 28.2369,
  x2: 91,
  y2: 154.317,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_37490_36898",
  x1: 154.622,
  y1: 28.2367,
  x2: 154.622,
  y2: 154.317,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_37490_36898",
  x1: 21.1284,
  y1: 28.237,
  x2: 21.1284,
  y2: 154.317,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_37490_36898",
  x1: 85.3035,
  y1: 66.8496,
  x2: 99.2428,
  y2: 115.362,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_37490_36898",
  x1: 40.8412,
  y1: 163.033,
  x2: 88.7946,
  y2: 79.1129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_37490_36898",
  x1: 113.176,
  y1: 77.9116,
  x2: 121.54,
  y2: 98.1718,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_37490_36898",
  x1: 114.402,
  y1: 77.4058,
  x2: 122.765,
  y2: 97.666,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_37490_36898",
  x1: 114.161,
  y1: 10.0222,
  x2: 114.161,
  y2: 45.8106,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_37490_36898",
  x1: 114.16,
  y1: 15.1635,
  x2: 114.16,
  y2: 30.3495,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCD2D6",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD2D6"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_37490_36898"
}, /*#__PURE__*/React.createElement("rect", {
  width: 182,
  height: 182,
  fill: "white",
  transform: "translate(0 0.5)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarNoNewFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_no_new_file.e32ca104c187169c037fbde688eba3ca.svg";